import styled from 'styled-components';

import { Box } from 'ui';

export const Divider = styled(Box)`
  background: ${({ theme: { colors } }) => colors.gray10};
  height: 1px;
  max-width: 100%;
`;
